import { render } from "./imageCarouselTemplate.vue?vue&type=template&id=71697532&scoped=true"
import script from "./imageCarouselTemplate.vue?vue&type=script&lang=js"
export * from "./imageCarouselTemplate.vue?vue&type=script&lang=js"

import "./imageCarouselTemplate.vue?vue&type=style&index=0&id=71697532&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\niso\\Documents\\repos\\storyworld-everhouse-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71697532"]])

export default __exports__